import { showFormDialog } from '../showFormDialog';
export function showWidgetEditDialog(props, endEditing, params, ...tabs) {
    const rules = props.rootParams.rules;
    const rulesListValues = rules.map((rule) => ({ value: rule.type, label: rule.label }));
    if (rules && rules.length > 0) {
        tabs.push({
            label: 'Rules',
            onSubmit: (data) => {
                if (data.rules && data.rules.length === 0) {
                    delete data.rules;
                }
                return data;
            },
            children: [
                {
                    type: 'form.checkboxList',
                    key: 'rules',
                    values: rulesListValues,
                },
            ],
        });
    }
    showFormDialog({
        maxWidth: 'lg',
        title: params.title,
        config: {
            type: 'form',
            onLoad: (data) => {
                data = JSON.parse(JSON.stringify(data));
                for (const tab of tabs) {
                    if (tab.onLoad) {
                        data = tab.onLoad(data);
                    }
                }
                return data;
            },
            onSubmit: (data) => {
                for (const tab of tabs) {
                    if (tab.onSubmit) {
                        data = tab.onSubmit(data);
                    }
                }
                return data;
            },
            children: [
                {
                    type: 'form.tabs',
                    tabs: [
                        ...tabs.map((tab) => ({
                            label: tab.label,
                            children: tab.children,
                        })),
                    ],
                },
            ],
        },
        data: props.config,
        valueProviders: props.rootParams.valueProviders,
        subFormProviders: props.rootParams.subFormProviders,
        sx: {
            minHeight: 'min(calc(100vh - 264px), 600px)',
        },
        onSubmit: (data) => endEditing(data),
        onCancel: () => endEditing(),
    });
}
